module.exports = __webpack_public_path__ + "static/media/OpenSans.629a55a7.ttf";